import apiPaths from "../../../api/endpoints";

export interface MagicPackItem {
  id?: string | number;
  documentId?: string;
  title: string;
  description?: string;
  contentType: string;  // "Video" | "Audio" | "Image" | "Book"
  answerContent: string; // media URL
  coverImage?: string;
  duration?: number;
  seen?: boolean;
  question?: string;
  timestamp?: string;
}

/** Backpack media types we support */
export type BackpackType = "video" | "audio" | "image" | "book";

export function backpackApiPathFor(type: BackpackType): string {
  switch (type) {
    case "audio": return apiPaths.GET_MAGIC_BACKPACK_AUDIO;
    case "image": return apiPaths.GET_MAGIC_BACKPACK_IMAGE;
    case "book":  return apiPaths.GET_MAGIC_BACKPACK_BOOK;
    default:      return apiPaths.GET_MAGIC_BACKPACK_VIDEO;
  }
}

export function backpackTitleFor(type: BackpackType): string {
  switch (type) {
    case "audio": return "What would you like to listen?";
    case "image": return "What would you like to see?";
    case "book":  return "What would you like to read?";
    default:      return "What would you like to watch?";
  }
}

/** Mobile getTwoModuleItems — first two items as a featured row */
export function getTwoModuleItems<T>(arr: T[] | undefined): T[] {
  if (!arr) return [];
  return arr.slice(0, 2);
}
